"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var useStyles = function useStyles() {
  return (0, _core.makeStyles)(function () {
    return {
      divider: {
        borderBottom: '1px solid rgba(256, 256, 256, 0.14)',
        borderTop: '1px solid rgba(0, 0, 0, 0.6)',
        height: 0,
        marginBottom: 15,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 15,
        maxHeight: 0
      }
    };
  })();
};
var SidenavDivider = function SidenavDivider() {
  var styleClasses = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styleClasses.divider
  }, " ");
};
var _default = SidenavDivider;
exports["default"] = _default;